import {parse} from "mathjs";
import {parseIntervalInput} from "../../components/inputs/IntervalInput";
export const isCommonDenominatorTask=t=>t?.type==="MaturaBasic_CommonDenominatorRationalLinearEquation";
const raw=v=>String(typeof v==="object"?v?.raw??"":v??"").trim();
const near=(a,b)=>Number.isFinite(a)&&Math.abs(a-b)<1e-8;
export function commonDenominatorFields(built,task){
 if(!isCommonDenominatorTask(task))return built;
 const [a,d,k]=task.data.values;
 return {...built,automatic:true,results:[
  {key:"domain",label:"Dziedzina lub założenie",kind:"interval",latex:`\\mathbb R\\setminus\\{${d}\\}`},
  {key:"equation",label:"Równanie liniowe lub kwadratowe po usunięciu mianowników",latex:`${k}(x+${a})=x`},
  {key:"x",label:"Rozwiązanie — liczba, ułamek lub zbiór {…}",latex:String(-k*a/(k-1))},
 ]};
}
export function gradeCommonDenominator(task,answer={},polynomialMatches){
 const [a,d,k]=task.data.values,target=-k*a/(k-1);
 const domainText=raw(answer.domain),domainParsed=parseIntervalInput(domainText);
 let domain=false;
 const exclusion=domainText.match(/^x\s*(?:!=|≠|\\ne(?:q)?)\s*(-?\d+(?:\.\d+)?)$/);
 if(exclusion)domain=near(Number(exclusion[1]),d);
 if(domainParsed?.kind==="complement")domain=domainParsed.points.length===1&&near(domainParsed.point,d);
 if(domainParsed?.kind==="intervals"){
  const intervals=[...domainParsed.intervals].sort((a,b)=>a.left-b.left);
  domain=intervals.length===2&&intervals[0].left===-Infinity&&near(intervals[0].right,d)&&!intervals[0].rightClosed&&near(intervals[1].left,d)&&!intervals[1].leftClosed&&intervals[1].right===Infinity;
 }
 const equationText=raw(answer.equation).replace(/−/g,"-");
 let equation=false;
 try{
  const sides=equationText.split("=");
  if(equationText.length<=600&&sides.length===2&&sides.every(s=>s.trim())){
   const difference=`(${sides[0]})-(${sides[1]})`.replace(/x\(/g,"x*("),tree=parse(difference),f=x=>Number(tree.evaluate({x}));
   tree.traverse(node=>{if(!(node.isConstantNode||node.isParenthesisNode||node.isOperatorNode||(node.isSymbolNode&&node.name==="x")))throw Error("Unsupported expression");});
   const c0=f(0),c2=(f(2)-2*f(1)+c0)/2,c1=f(1)-c0-c2,coeff=[c0,c1,c2];
   if(polynomialMatches(difference.replace(/x/g,"r"),coeff)){
    equation=[[k*a,k-1,0],[-k*a*d,k*(a-d)+d,k-1]].some(expected=>{
     const i=expected.findIndex(v=>v!==0),scale=coeff[i]/expected[i];
     return Number.isFinite(scale)&&Math.abs(scale)>1e-10&&coeff.every((v,j)=>Math.abs(v-scale*expected[j])<1e-8*Math.max(1,Math.abs(v)));
    });
   }
  }
 }catch{}
 const solutionText=raw(answer.x).replace(/^x\s*(?:=|∈)/,"");
 const set=parseIntervalInput(solutionText);
 let roots=[];
 if(set?.kind==="finite")roots=set.points;
 else {try{const value=parse(solutionText).evaluate();if(typeof value==="number"&&Number.isFinite(value))roots=[value];}catch{}}
 const result=roots.length===1&&near(roots[0],target);
 const candidates=result||(roots.length===2&&roots.some(x=>near(x,target))&&roots.some(x=>near(x,d)));
 const score=equation&&domain&&result?3:equation&&(domain||candidates)?2:equation||domain?1:0;
 return {correct:score===3,isCorrect:score===3,score,maxScore:3,parts:{domain,equation,result},incomplete:![domainText,equationText,raw(answer.x)].some(Boolean),message:set?.kind==="ambiguous" ? "Nie można jednoznacznie odczytać zbioru. Oddziel liczby średnikiem." : "Zapisz dziedzinę, przekształcone równanie i wynik. Możesz oddać niepełne rozwiązanie za punkty częściowe."};
}
